module.exports = __webpack_public_path__ + "static/cappuccino_latte-48b46b37c42311b2e05c71a41e8eceab.png";